import {HTTP, HTTP_API_V2} from '../../http-common'

export default {
  state: {
    loadedBarns: [],
    loadedBarnsV2: []
  },
  getters: {
    loadedBarns (state) {
      return state.loadedBarns
    },
    loadedBarnsV2 (state) {
      return state.loadedBarnsV2
    }
  },
  mutations: {
    setLoadedBarns (state, payload) {
      state.loadedBarns = payload
    },
    setLoadedBarnsV2 (state, payload) {
      state.loadedBarnsV2 = payload
    },
    createBarn (state, payload) {
      state.loadedBarns.push(payload)
    },
    updateBarn (state, payload) {
      state.loadedBarns = state.loadedBarns.map(barn => barn.id === payload.id ? payload : barn)
    },
    removeBarn (state, id) {
      state.loadedBarns = state.loadedBarns.filter(barn => {
        return barn.id !== id
      })
    },
    clearLoadedBarns (state) {
      state.loadedBarns = []
    }
  },
  actions: {
    loadBarns ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedBarns', [])

      return new Promise((resolve, reject) => {
        HTTP.get('barn.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedBarns', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    loadBarnsV2 ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedBarnsV2', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('barns/')
          .then(result => {
            const retroCompatibleResult = result.data.map(barn => {
              return {
                id: barn.id,
                description: barn.description,
                nucleus: barn.nucleus,
                permission: barn.permissions,
                details: barn.details,
                devices: barn.devices
              }
            })
            commit('setLoadedBarnsV2', retroCompatibleResult)
            resolve(retroCompatibleResult)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err.message)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createBarn ({ commit, getters }, payload) {
      console.log('createBarn')
      commit('clearError')
      commit('setLoading', true)
      const newBarn = {
        description: payload.description,
        width: payload.width,
        height: payload.height,
        length: payload.length,
        nucleus: {
          id: payload.nucleus.id
        },
        barn_type: {
          id: payload.barn_type.id
        },
        inner_curtain: {
          id: payload.inner_curtain.id
        },
        outer_curtain: {
          id: payload.outer_curtain.id
        },
        air_inlet: {
          id: payload.air_inlet.id
        },
        lighting_system: {
          id: payload.lighting_system.id
        },
        wall_type: {
          id: payload.wall_type.id
        },
        floor_type: {
          id: payload.floor_type.id
        },
        roof_type: {
          id: payload.roof_type.id
        },
        lining_type: {
          id: payload.lining_type.id
        },
        internet_access_type: {
          id: payload.internet_access_type.id
        },
        voltage_type: {
          id: payload.voltage_type.id
        }
      }
      console.log('newBarn', newBarn)
      return new Promise((resolve, reject) => {
        HTTP.post('barn.json/', newBarn)
          .then(result => {
            console.log(result)
            commit('createBarn', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log('estou no erro aqui')
            console.log(err.data)
            console.log(err.statusText)
            console.log(err.status)
            console.log('meu erro aqui', err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateBarn ({ commit, getters }, payload) {
      console.log('updateBarn')
      commit('clearError')
      commit('setLoading', true)
      const barn = {
        description: payload.description,
        width: payload.width,
        height: payload.height,
        length: payload.length,
        nucleus: {
          id: payload.nucleus.id
        },
        barn_type: {
          id: payload.barn_type.id
        },
        inner_curtain: {
          id: payload.inner_curtain.id
        },
        outer_curtain: {
          id: payload.outer_curtain.id
        },
        air_inlet: {
          id: payload.air_inlet.id
        },
        lighting_system: {
          id: payload.lighting_system.id
        },
        wall_type: {
          id: payload.wall_type.id
        },
        floor_type: {
          id: payload.floor_type.id
        },
        roof_type: {
          id: payload.roof_type.id
        },
        lining_type: {
          id: payload.lining_type.id
        },
        internet_access_type: {
          id: payload.internet_access_type.id
        },
        voltage_type: {
          id: payload.voltage_type.id
        }
      }
      console.log('barn', barn)
      return new Promise((resolve, reject) => {
        HTTP.patch(`barn.json/${payload.id}/`, barn)
          .then(result => {
            console.log(result)
            commit('updateBarn', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeBarn ({ commit }, payload) {
      console.log('removeBarn')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`barn.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeBarn', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedBarns ({ commit }) {
      commit('clearLoadedBarns')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/barn/index.js